module.exports = __webpack_public_path__ + "media/images/app-store-badge-15f01eefb2013206cc7e26d98fbe95fb.svg";